/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Jun 23 2023
 **/

export const GROUP_POPOVER_ID = {
	MY_PROFILE_STATUS: "MY_PROFILE_STATUS",
	PROFILE_STATUS_SETTINGS: "PROFILE_STATUS_SETTINGS",
	AVATAR_MINI_PROFILE: "AVATAR_MINI_PROFILE",
	MINI_CHAT_OPTION: "MINI_CHAT_OPTION",
	SPACE_MORE_MENU: "SPACE_MORE_MENU",
	SPACE_CHAT_SUB_MENU: "SPACE_CHAT_SUB_MENU",
	CHAT_OPTION: "CHAT_OPTION",
	FILE_MORE_MENU: "FILE_MORE_MENU",
	MYROOM_MORE_MENU: "MYROOM_MORE_MENU",
	SET_BACKGROUND_MYDESK: "SET_BACKGROUND_MYDESK",
	NEW_MEMBER_INVITE: "NEW_MEMBER_INVITE",
	MYDESK_SHORTCUT_GROUP: "MYDESK_SHORTCUT_GROUP"
} as const;
export type GROUP_POPOVER_ID = (typeof GROUP_POPOVER_ID)[keyof typeof GROUP_POPOVER_ID];

export const POPOVER_ID = {
	CHAT_SUB_MENU: "CHAT_SUB_MENU",
	CHAT_SIDEBAR_MORE: "CHAT_SIDEBAR_MORE",
	CHAT_HEADER_MORE: "CHAT_HEADER_MORE",
	TIP_INVALID_INFO: "TIP_INVALID_INFO",
	FRIEND_MORE: "FRIEND_MORE",
	COLOR_PALETTE: "COLOR_PALETTE",
	GROUP_SPACE_LIST_SORT: "GROUP_SPACE_LIST_SORT",
	GROUP_PANEL_MORE: "GROUP_PANEL_MORE",
	SETTING_LEAVE: "SETTING_LEAVE",
	SPACE_MEMBER_MANAGEMENT: "SPACE_MEMBER_MANAGEMENT",
	SPACE_PANEL_MORE: "SPACE_PANEL_MORE",
	SPACE_PANEL_SHARE: "SPACE_PANEL_SHARE",
	SPACE_GROUP_MORE: "SPACE_GROUP_MORE",
	GROUP_MORE_MENU: "GROUP_MORE_MENU",
	PEOPLE_USER_MORE: "PEOPLE_USER_MORE",
	PEOPLE_GROUP_MORE: "PEOPLE_GROUP_MORE",
	NAVIGATION_PROFILE_MORE: "NAVIGATION_PROFILE_MORE",
	MINIMIZE_CHAT_MORE: "MINIMIZE_CHAT_MORE",
	EMOJI_PICKER: "EMOJI_PICKER",
	EMOJI_TOTAL_PICKER: "EMOJI_TOTAL_PICKER",
	STATUS_EMOJI_PICKER: "STATUS_EMOJI_PICKER",
	USER_PROFILE_EDIT: "USER_PROFILE_EDIT",
	NOTIFICATION: "NOTIFICATION",
	PHONE_USER_MORE: "PHONE_USER_MORE",
	CHANGE_SPACE_CHAT_ALARM: "CHANGE_SPACE_CHAT_ALARM",
	CHAT_EMOTICON_PICKER: "CHAT_EMOTICON_PICKER",
	VOICECALL_USER_LIST: "VOICECALL_USER_LIST",
	CHAT_UI_OPTION: "CHAT_UI_OPTION",
	BACKGROUND_UI_POPUP: "BACKGROUND_UI_POPUP",
	ADD_CALL_USER: "ADD_CALL_USER",
	SETTING_WIDGET: "SETTING_WIDGET",
	SPACE_LIST_PARTICIPANT: "SPACE_LIST_PARTICIPANT",
	CHAT_IMAGE_SUB_MENU: "CHAT_IMAGE_SUB_MENU",
	SETTING_SHORTCUT: "SETTING_SHORTCUT",
	MYDESK_KNOCK: "MYDESK_KNOCK",
	DOWNLOAD_FILE: "DOWNLOAD_FILE",
	VOTE_MORE: "VOTE_MORE",
	PROFILE_IMAGES: "PROFILE_IMAGES",
	ACTIVITY_PANEL_MORE: "ACTIVITY_PANEL_MORE"
} as const;

export type POPOVER_ID = (typeof POPOVER_ID)[keyof typeof POPOVER_ID];
